import { Link } from 'react-router-dom';
import AttendancePage from '../../components/attendancePage';
import { FloorAttendanceRoute } from '../../routes/routepath';

const UserAttendance = () => (
  <AttendancePage
    userType="user"
    title="Member Attendance"
    showFloorFilter
    extra={<Link to={FloorAttendanceRoute}>Floor-wise view →</Link>}
  />
);

export default UserAttendance;
